import {Component, Inject, Vue} from "vue-property-decorator";
import {isUuid} from "~/lib/helpers";
import {AppSettings} from "~/lib/app-settings";

@Component
class ClientHome extends Vue {
  @Inject() appSettings: AppSettings;

  async created() {
    if (!isUuid(this.appSettings.clientUUID)) {
      await this.$router.push({ name: 'partner_home' });
    }
  }

  render() {
    return <router-view />;
  }
}

export { ClientHome };

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2acb0659/index.tsx" });